// src/utils/imageUtils.js
import { WATERMARK_URL } from './constants';

// ============================================
// WATERMARK
// ============================================
export const applyWatermark = async (imageFile) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    const watermark = new Image();
    
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      
      watermark.onload = () => {
        const wmWidth = img.width * 0.3;
        const wmHeight = (watermark.height / watermark.width) * wmWidth;
        const x = img.width - wmWidth - 20;
        const y = img.height - wmHeight - 20;
        
        ctx.globalAlpha = 0.6;
        ctx.drawImage(watermark, x, y, wmWidth, wmHeight);
        
        canvas.toBlob((blob) => {
          resolve(blob);
        }, 'image/jpeg', 0.9);
      };
      
      watermark.onerror = () => resolve(imageFile);
      watermark.src = WATERMARK_URL;
    };
    
    img.onerror = () => reject(new Error('Failed to load image'));
    img.src = URL.createObjectURL(imageFile);
  });
};

// ============================================
// UPLOAD DO CLOUDINARY
// ============================================
const uploadToCloudinary = async (blob) => {
  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
  const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

  if (!cloudName || !uploadPreset) throw new Error('Brak konfiguracji Cloudinary');

  const formData = new FormData();
  formData.append('file', blob, 'photo.jpg');
  formData.append('upload_preset', uploadPreset);
  formData.append('folder', 'motoradar');

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
    { method: 'POST', body: formData }
  );

  if (!res.ok) throw new Error(`Cloudinary error: ${res.status}`);
  const data = await res.json();

  const full = data.secure_url;
  // Auto-thumbnail przez Cloudinary URL transformację (400x300, crop, auto format)
  const thumb = full.replace('/upload/', '/upload/w_400,h_300,c_fill,q_auto,f_auto/');

  return { full, thumb };
};

// ============================================
// UPLOAD — tylko Cloudinary
// ============================================
export const uploadImage = async (blob, onStatus) => {
  try {
    onStatus?.('Wysyłanie...');
    const urls = await uploadToCloudinary(blob);
    console.log('[Upload] Cloudinary ✅');
    return urls;
  } catch (error) {
    console.error('[Upload] Cloudinary failed', error.message);
    throw new Error('Upload nieudany - spróbuj ponownie');
  }
};

// ============================================
// HELPER: processImage + upload w jednym
// ============================================
export const processAndUpload = async (file, onStatus) => {
  // 1. Watermark
  onStatus?.('Znak wodny...');
  const watermarked = await applyWatermark(file).catch(() => file);

  // 2. Upload
  const url = await uploadImage(watermarked, onStatus);
  return url;
};